import { parseBigintList, splitCsvOrArray } from "./util/queryParams.mjs";
import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/decoration.ts
const decorationSchema = z.object({
	id: z.string(),
	code: z.string(),
	type: z.enum([
		"BADGE",
		"AVATAR_FRAME",
		"ARTWORK_FRAME",
		"LIVE_BANNER"
	]),
	description: z.string().nullable().optional(),
	allowUserEditRemark: z.boolean(),
	createdAt: z.iso.datetime(),
	updatedAt: z.iso.datetime(),
	data: z.unknown()
});
const publicDecorationSchema = decorationSchema.pick({
	id: true,
	code: true,
	type: true,
	data: true,
	createdAt: true,
	updatedAt: true
});
const batchInputSchema = z.object({ ids: z.union([z.string(), z.array(z.string())]).transform((value, ctx) => parseBigintList(splitCsvOrArray(value), ctx, {
	min: 1,
	max: 50
})).describe("Decoration IDs to fetch (1–50). Accepts comma-separated (`?ids=1,2,3`), bracket notation (`?ids[]=1&ids[]=2`), or repeated (`?ids=1&ids=2`).") });
const batchOutputSchema = z.object({ data: z.array(publicDecorationSchema) });
const decorationContract = oc.prefix("/decoration").tag("Decoration").router({
	batch: oc.route({
		method: "GET",
		path: "/batch",
		summary: "Batch get decorations by IDs",
		description: "Returns decorations matching the given IDs, ordered to match the input `ids`. Unknown IDs are silently omitted. Capped at 50 IDs per request."
	}).input(batchInputSchema).output(batchOutputSchema),
	getDecoration: oc.route({
		method: "GET",
		path: "/{id}",
		summary: "Get decoration by ID"
	}).input(z.object({ id: z.coerce.bigint() })).output(publicDecorationSchema).errors({ NOT_FOUND: {
		status: 404,
		message: "Decoration not found"
	} })
});
//#endregion
export { decorationContract, decorationSchema };
